import React from 'react'
import styled from 'styled-components'

const Root = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  & > p {
    color: ${({ $color }) => $color};
    opacity: 1 !important;
    font-weight: 500;
    margin-left: 0.5rem !important;
  }
`

const LangIcon = ({ fill, path }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="24"
    viewBox="0 0 24 24"
    width="24"
  >
    <path fill={fill} d={path} />
  </svg>
)

export const LanguageChip = ({ color, icon, name }) => {
  return (
    <Root $color={color}>
      <LangIcon fill={color} path={icon} />
      {/* <p>{name} <span>→</span></p> */}
      <p>{name}</p>
    </Root>
  )
}
